import { combineReducers } from 'redux';
import eventsReducer from './events';
import boothsReducer from './booths';

export default combineReducers({
  events: eventsReducer,
  booths: boothsReducer,
});
